import { makeAutoObservable } from 'mobx';
import { validateBounceEma } from './validateBounceEma';

export class BounceEmaData {
  candleDuration = 1;
  timeUnit = 'MINUTES';
  periodLengths = [];

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.candleDuration = 1;
    this.timeUnit = 'MINUTES';
    this.periodLengths = [];
  };

  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };

  validate = () => {
    const data = {
      candleDuration: this.candleDuration,
      timeUnit: this.timeUnit,
      periodLengths: this.periodLengths,
    };
    const result = validateBounceEma(data);
    return result;
  };

  returnJson = () => {
    return {
      candleDuration: this.candleDuration,
      timeUnit: this.timeUnit,
      periodLengths: this.periodLengths,
    };
  };

  //specific methods
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setTimeUnit = (string) => {
    this.timeUnit = string;
  };
  addPeriod = (period) => {
    this.periodLengths.push(period);
  };
  removePeriod = (index) => {
    const newArray = this.periodLengths.filter((_item, i) => i !== index);
    this.periodLengths = newArray;
  };
  clearPeriods = () => {
    this.periodLengths = [];
  };
}
